import React from "react";
import styles from "./index.module.css"

export default ({ children }) => (
  <div className={styles['panoramic']}>{children}</div>
);



// WEBPACK FOOTER //
// ./src/components/panoramic.js